import CommonLayout from 'components/CommonLayout';
import Body from 'containers/LegalNoticePage/Body';
import messages from 'containers/LegalNoticePage/messages';
import React from 'react';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';

const LegalNoticePage = () => {
  return (
    <GaLoadHOC
      category={EVENT_CATEGORIES.LEGAL_NOTICE}
      label="Mentions légales"
    >
      <CommonLayout title={messages.legalNoticeTitle} content={<Body />} />
    </GaLoadHOC>
  );
};

export default LegalNoticePage;
